module.exports = __webpack_public_path__ + "img/06.b2b5661d.png";